import { ReactNode, useLayoutEffect, useRef } from 'react'

// Trava tudo o que é editável dentro (inclusive modais abertos ali dentro) para telas de consulta.
// Continuam livres: cabeçalho/rodapé de modal (Fechar, Imprimir), abas e o que estiver em [data-livre]; o Salvar (.btn-orange) some.
const LIVRE = '[data-livre], .modal-header, .modal-footer'
const ABAS = '.modal-aba, .exm-aba'
const CSS = `.zona-ro .btn-orange { display: none !important; }
.zona-ro .nat-desc-box:not([data-livre] .nat-desc-box) { pointer-events: none; background: #f3f4f6; }`

export default function ZonaSomenteLeitura({ ativo, children }: { ativo: boolean; children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const el = ref.current
    if (!ativo || !el) return
    const travar = () => {
      el.querySelectorAll<HTMLInputElement>('input, select, textarea, button').forEach(n => {
        if (n.disabled || n.closest(LIVRE) || n.matches(ABAS)) return
        n.disabled = true
      })
      el.querySelectorAll<HTMLElement>('.nat-desc-box').forEach(n => { if (!n.closest('[data-livre]')) n.tabIndex = -1 })
    }
    travar()
    // modais e linhas aparecem depois; reaplica a cada mudança
    const mo = new MutationObserver(travar)
    mo.observe(el, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] })
    return () => mo.disconnect()
  }, [ativo])

  if (!ativo) return <>{children}</>
  return (
    <div ref={ref} className="zona-ro" style={{ display: 'contents' }}>
      <style>{CSS}</style>
      {children}
    </div>
  )
}
